$( document ).ready(function() {
  $('.products--slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    dots:true,
    arrow:false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
    
  });
  
  $('.slick-arrow').text("");
  
  $('.left').click(function(){
  $('.slider').slick('slickPrev');
   
  });

  $('.right').click(function(){
    $('.slider').slick('slickNext');
  });
  

   setTimeout(function(){
      $("#main-loader").css('opacity','0');
      $("#main-loader").css('transition','visibility 0s 0.5s, opacity 0.5s linear');
    }, 1000); 

});

